import { render, staticRenderFns } from "./DUDHome.vue?vue&type=template&id=22ec6068&scoped=true&"
import script from "./DUDHome.vue?vue&type=script&lang=ts&"
export * from "./DUDHome.vue?vue&type=script&lang=ts&"
import style0 from "./DUDHome.vue?vue&type=style&index=0&id=22ec6068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec6068",
  null
  
)

export default component.exports